import { Badge, BadgeProps, styled } from "@mui/material";

export const BadgeWithOffset = styled(Badge)<BadgeProps>(() => ({
  "& .MuiBadge-badge": {
    right: 12,
    top: 12,
    padding: "0 4px"
  }
}));
